import { render } from "./TemplateLiveView.vue?vue&type=template&id=0aaca7aa&scoped=true"
import script from "./TemplateLiveView.vue?vue&type=script&lang=ts"
export * from "./TemplateLiveView.vue?vue&type=script&lang=ts"

import "./TemplateLiveView.vue?vue&type=style&index=0&id=0aaca7aa&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0aaca7aa"

export default script